
    <div class="overlay-container">
      <h1 class="modal-title">{{ data.title }}</h1>
      <p class="modal-message">{{ data.message }}</p>
      <button class="modal-close-button btn btn-primary btn-primary--with-hover" (click)="closeModal()">Close</button>
    </div>
  